// extracted by mini-css-extract-plugin
export default {"consumables":"consumables-YmIDH","table":"table-gWKib"};